module.exports = __webpack_public_path__ + "img/hlgbanner.ae3c9315.png";